module.exports = __webpack_public_path__ + "static/media/peaks.e2c4415a.jpg";